module.exports = __webpack_public_path__ + "img/fighting.1db9be63.jpg";